import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import './blogs.css'

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      const snapshot = await getDocs(collection(db, "blogs"));
      const data = snapshot.docs.map(doc => doc.data());
      setBlogs(data);
      setLoading(false);
    };

    fetchBlogs();
  }, []);

  return (
  <>
  <Helmet>
    <title>Insights & Growth Blogs | Almond Softwares</title>
  </Helmet>
  <div className="blogs-page">
    <div className="bg-luxury"></div>
    <div className="container">
      <motion.h1 
        className="blog-main-title"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Insights & Growth Blogs
      </motion.h1>

      <div className="blog-grid">
        {loading ? (
           <div className="spinner-container"><div className="spinner"></div></div>
        ) : (
           blogs.map((blog, i) => (
            <motion.div 
              key={i} 
              className="blog-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <div className="blog-content">
                <h2>{blog.title}</h2>

                <Link to={`/blog/${blog.slug}`} className="read-more">
                  Read More →
                </Link>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  </div>
  </>
);
}